/* eslint-disable no-unused-vars */
import {
  post,
  get,
  postFile,
  getConcurrent,
  postConcurrent,
  concurrentRequest
} from '../utils/request' // 引入请求

/* 工具类 */
export const createSms = (data, callback) =>
  post('home/createSms', data, callback) // 获取验证码

/* 首页 */
// 废弃接口
export const login = (data, callback) => post('home/login', data, callback) // 前台登录 废弃
export const register = (data, callback) =>
  post('home/register', data, callback) // 前台注册 废弃
// 正常接口
export const getCategory = (data, callback) =>
  post('home/getCategory', data, callback) // 获取资源分类列表
export const searchProduct = (data, callback) =>
  post('home/searchProduct', data, callback) // 搜索商品
export const getHotProduct = (data, callback) =>
  post('home/getHotProduct', data, callback) // 获取热门商品
export const getHotModule = (data, callback) =>
  post('/home/getModuleProduct', data, callback) // 获取模板推荐
export const getBanner = (data, callback) =>
  post('home/getBanner', data, callback) // 获取轮播图
// 新增接口
export const getToken = (data, callback) =>
  post('home/getToken', data, callback) // 获取token

/* 个人中心页 */
export const getCollect = (data, callback) =>
  post('App/personal/getCollect', data, callback) // 获取我的收藏
export const getOrder = (data, callback) =>
  post('App/personal/getOrder', data, callback) // 获取我的购买

/* 下载管理页 */
export const getDownloadList = (data, callback) =>
  post('App/download/getRecord', data, callback) // 获取下载记录
// 本接口在下载组件中复用，用来新增下载记录
export const editDownloadRecord = (data, callback) =>
  post('App/download/editRecord', data, callback) // 新增/修改下载记录

/* 图片/字体/特效/音频/视频资源页 */
export const getCategoryByType = (data, callback) =>
  post('product/getCategory', data, callback) // 获取某类的资源分类
export const getList = (data, callback) =>
  post('product/getList', data, callback) // 获取资源列表
export const getDetail = (data, callback) =>
  post('product/getDetail', data, callback) // 获取资源详情
export const buyResource = (data, callback) =>
  post('App/product/buyResource', data, callback) // 购买资源
export const download = (data, callback) =>
  post('App/product/download', data, callback) // 下载资源
export const toggleCollect = (data, callback) =>
  post('App/product/toggleCollect', data, callback) // 切换收藏
export const assess = (data, callback) =>
  post('/product/assess', data, callback) // 点赞

/* 机器码验证是否允许进入该网站 */
export const checkCode = (data, callback) =>
  post('home/checkCode', data, callback) // 获取是否允许访问
export const activationCode = (data, callback) =>
  post('home/generateActivationCode', data, callback) // 生成激活码
export const cdkey = (data, callback) =>
  post('/api/v2/code/generateActivationCode', data, callback) // 生成激活码
export const getNotLateActivationCode = (data, callback) =>
  post('/api/v2/code/getNotLateActivationCode', data, callback) // 获取未激活的激活码
export const editCodeByCdkey = (data, callback) =>
  post('/api/v2/code/editCodeByCdkey', data, callback) // 修改激活码相关数据
export const getCodePolylineTrend = (data, callback) =>
  post('/api/v2/activateRecord/getCodePolylineTrend', data, callback) // 获取每周激活频率
/* 后台设置热门商品接口 */
export const setHotProduct = (data, callback) =>
  post('admin/hot/setHotProduct', data, callback) // 获取是否允许访问
